import React, { useEffect } from "react";
import "./MainLayout.scss";
import ErrorModal from "../Components/ErrorModal/ErrorModal";
import OverallLoading from "../Components/OverallLoading/OverallLoading";
import { Route, Routes } from "react-router-dom";
import { MainRoutes } from "../Routes/routes";
import Header from "./Header/Header";
import useGetRestaurant from "./hooks/useGetRestaurant";
import useGetBkey from "./hooks/useGetBkey";
import useCheckAuth from "./hooks/useCheckAuth";
import useGetBranch from "./hooks/useGetBranch";
import {useAppSelector} from "../Redux/store";
import AppLoader from "../Containers/AppLoader/AppLoader";
import BranchErrorOverlay from "../Components/BranchErrorOverlay/BranchErrorOverlay";

const MainLayout = () => {
  const { onGetBranch } = useGetBranch();
  const { onGetRestaurant } = useGetRestaurant();
  const { checkClientID } = useCheckAuth();
  const { getKey } = useGetBkey();


  useEffect(() => {
      onGetBranch();
    onGetRestaurant();
    checkClientID(getKey());
  }, []);
  const branchLoading = useAppSelector(state => state.overall.branchLoading);
    if (branchLoading) {
        return (
            <>
                <AppLoader />
                <BranchErrorOverlay />
            </>
        );
    }
  return (
    <div className="main-layout">
      {/* Phần chính */}
      <Header />

      {/* Routers */}
      <Routes>
        {MainRoutes.map((a, index) => (
          <Route key={index} {...a} />
        ))}
      </Routes>

      {/* Các supporting modal */}
      <ErrorModal />
      <OverallLoading />
        <BranchErrorOverlay />
    </div>
  );
};

export default React.memo(MainLayout);
